(function($) {

    console.log('is loaded');

	// $('#amritExpertsSliderone').slick({
	// 	fade: true,
	// 	arrows: false,
	// 	dots: true,
    //     dotsClass: 'sliderDots',
    //     adaptiveHeight: true
	// });

    // $('#amritExpertsSlidertwo').slick({
	// 	fade: true,
	// 	arrows: false,
	// 	dots: true,
    //     dotsClass: 'sliderDots',
    //     adaptiveHeight: true
	// });

    // $('#amritExpertsSliderthree').slick({
	// 	fade: true,
	// 	arrows: false,
	// 	dots: true,
    //     dotsClass: 'sliderDots',
    //     adaptiveHeight: true
	// });

    $('#stats').slick({
		arrows: false,
		dots: true,
        dotsClass: 'sliderDotsStats',
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 474,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1023,
                settings: "unslick"
            }
        ]
    });

    $('#ingredientSlider').slick({
        arrows: false,
		dots: true,
        dotsClass: 'sliderDotsIngredients',
        infinate: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 474,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 1023,
                settings: "unslick"
            }
        ]
    });

    $('#ingredientRowSlider').slick({
        arrows: false,
		dots: true,
        dotsClass: 'sliderDotsIngredients',
        appendDots: '.sliderDotsIngredients2',
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 474,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1023,
                settings: "unslick"
            }
        ]
    });

    $('#columnSlider').slick({
        arrows: false,
		dots: true,
        dotsClass: 'sliderDotsColumns',
        appendDots: '.sliderDotsColumns2',
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 1023,
                settings: "unslick"
            }
        ]
    });

    $('.reelsSlider').on('init', function(event, slick){
        $('.reelsSlider').each(function(){

            var dots = $(this).find('.reelsDots li');

            console.log(dots.length);

            if( dots.length == 1 || dots.length == 0 ) {
                $(this).find('.reelsDots').hide();
            }

        });
    });

    $('.reelsSlider').slick({
        arrows: false,
		dots: true,
        dotsClass: 'reelsDots',
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('#iconGridSlider').slick({
		arrows: false,
		dots: true,
        dotsClass: 'sliderDotsGrid',
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 474,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1023,
                settings: "unslick"
            }
        ]
    });

    if ($(window).width() < 767) {
        $('.amritExpertSlider').each(function() {
            var title = $(this).find('h3');
            var open = $(title).find('.open');
            var close = $(title).find('.close');
            var content = $(this).find('.accordionContent');
            var sliderID = $(title).attr('data-sliderID');

            if( sliderID === 'one' ) {
                $(open).toggle();
                $(close).toggle();
                $(title).addClass('active');
                    $(content).slideDown();
            
                    $('#amritExpertsSlider'+sliderID).slick({
                        fade: true,
                        arrows: false,
                        dots: true,
                        dotsClass: 'sliderDots',
                        adaptiveHeight: true
                    });
            }

            $(title).click(function() {
                $(open).toggle();
                $(close).toggle();

                if( $(this).hasClass('active') ) {

                    $(title).removeClass('active');
                    $(content).slideUp();
            
                    $('#amritExpertsSlider'+sliderID).slick('unslick');

                } else {

                    $(title).addClass('active');
                    $(content).slideDown();
            
                    $('#amritExpertsSlider'+sliderID).slick({
                        fade: true,
                        arrows: false,
                        dots: true,
                        dotsClass: 'sliderDots',
                        adaptiveHeight: true
                    });
                }

            });
        });
    } else {
        $('.amritExpertSlider').each(function() {
            var title = $(this).find('h3');
            var open = $(title).find('.open');
            var close = $(title).find('.close');
            var content = $(this).find('.accordionContent');
            var sliderID = $(title).attr('data-sliderID');

            $(content).slideDown();
            $(open).hide();
            $(close).hide();
    
            $('#amritExpertsSlider'+sliderID).slick({
                fade: true,
                arrows: false,
                dots: true,
                dotsClass: 'sliderDots',
                adaptiveHeight: true
            });
        });
    }
    
})(jQuery);